<template>
	<div class="contentWarp">
		<!-- <div class="content_header">
			<div
				v-for="(item, index) in headers"
				v-bind:key="index"
				class="header"
				:style="{ width: 100 / headers.length + '%' }"
			>
				<div class="header_item" :style="{ background: item.background }"></div>
				<div style="display: inline-block">
					<div class="header_item_1" v-if="item.key === 'Total revenue'">
						{{ totalRevenue }}{{ item.unit }}
					</div>
					<div class="header_item_1" v-else-if="item.key === `Today revenue`">
						{{ todaysEarnings.toFixed(2) }}{{ item.unit }}
					</div>
					<div class="header_item_1" v-else-if="item.key === 'Number of orders today'">
						{{ orderTodayNum.toFixed(2) }}{{ item.unit }}
					</div>
					<div class="header_item_1" v-else-if="item.key === 'Subordinate account'">
						{{ SubordinateNum.toFixed(2) }}{{ item.unit }}
					</div>
					<div class="header_item_2">{{ item.title }}</div>
				</div>
			</div>
		</div> -->
		<div class="content_body">
			<!-- 搜索模块 -->
			<div class="search_bar">
				<div class="search_bar_item">
					<div class="search_bar_item_label">地区</div>
					<div class="">
						<a-input-group compact>
							<a-select
								v-model:value="searchModel.region"
								placeholder="国家列表"
								showSearch="true"
								:filter-option="
									(input, option) => {
										return option.text.indexOf(input) >= 0;
									}
								"
							>
								<a-select-option
									:text="item.text"
									:key="item.key"
									v-for="item in regionList"
									:value="item.key"
									>{{ item.text }}</a-select-option
								>
							</a-select>
						</a-input-group>
					</div>
				</div>
				<div class="search_bar_item">
					<div class="search_bar_item_label">账号</div>
					<div class="">
						<a-input v-model:value="searchModel.anchor_no" placeholder="请输入账号" />
					</div>
				</div>
				<!-- <div class="search_bar_item">
					<div class="search_bar_item_label">昵称</div>
					<div class="">
						<a-input v-model:value="searchModel.anchor_name" placeholder="请输入昵称" />
					</div>
				</div> -->
				<div class="search_bar_item_button">
					<button class="button_blue" @click="onPageChange(1, null)">搜索</button>
				</div>
			</div>
			<a-table
				:dataSource="datatable.dataSource"
				:columns="datatable.columns"
				:pagination="datatable.pagination"
			>
				<!-- <template #bodyCell="{ column, record }">
				</template> -->
			</a-table>
		</div>
	</div>
</template>

<script>
	//import util from '@/common/util';
	import userApi from '@/http/apiUtil/userApi';
	import '@/css/icon.scss';

	export default {
		components: {},
		props: {},
		data() {
			return {
				regionList: [
					{
						key: null,
						text: '其它国家',
					},
					{
						key: 'us',
						text: '美国',
					},
					{
						key: 'th',
						text: '泰国',
					},
					{
						key: 'gb',
						text: '英国',
					},
					{
						key: 'my',
						text: '马来西亚',
					},
					{
						key: 'ph',
						text: '菲律宾',
					},
					{
						key: 'kr',
						text: '韩国',
					},
					{
						key: 'id',
						text: '印度尼西亚',
					},
					{
						key: 'br',
						text: '巴西',
					},
					{
						key: 'de',
						text: '德国',
					},
					{
						key: 'ca',
						text: '加拿大',
					},
					{
						key: 'sg',
						text: '新加坡',
					},
					{
						key: 'au',
						text: '澳大利亚',
					},
					{
						key: 'tr',
						text: '土耳其',
					},
					{
						key: 'mx',
						text: '墨西哥',
					},
					{
						key: 'vn',
						text: '越南',
					},
					{
						key: 'jp',
						text: '日本',
					},
					{
						key: 'fr',
						text: '法国',
					},
					{
						key: 'tw',
						text: '台湾',
					},
				],
				searchModel: {},
				datatable: {
					dataSource: [],
					columns: [
						// {
						// 	title: '序号',
						// 	dataIndex: 'id',
						// 	key: 'id',
						// 	width: 100,
						// 	resizable: true,
						// },
						{
							title: 'TK账号',
							dataIndex: 'anchor_no',
							key: 'anchor_no',
							width: 200,
							resizable: true,
						},
						{
							title: '昵称',
							dataIndex: 'anchor_name',
							key: 'anchor_name',
							width: 200,
							resizable: true,
							ellipsis: true,
						},
						{
							title: '邮箱',
							dataIndex: 'bio_email',
							key: 'bio_email',
							width: 300,
							resizable: true,
							ellipsis: true,
						},
						{
							title: 'UID',
							dataIndex: 'anchor_uid',
							key: 'anchor_uid',
							width: 200,
							resizable: true,
						},
						{
							title: '地区',
							dataIndex: 'region',
							key: 'region',
							width: 100,
							resizable: true,
						},
						{
							title: '关注数',
							dataIndex: 'following_count',
							key: 'following_count',
							width: 100,
							resizable: true,
						},
						{
							title: '粉丝数',
							dataIndex: 'follower_count',
							key: 'follower_count',
							width: 100,
							resizable: true,
						},
						{
							title: '点赞数',
							dataIndex: 'dig_count',
							key: 'dig_count',
							width: 100,
							resizable: true,
						},

						{
							title: '小店',
							dataIndex: 'is_shop',
							key: 'is_shop',
							width: 80,
							resizable: true,
							customRender: (obj) => {
								return obj.record.is_shop == 0 ? '否' : '是';
							},
						},
						{
							title: '简介',
							dataIndex: 'signature',
							key: 'signature',
							width: 500,
							resizable: true,
						},
					],
					pagination: {
						pageNo: 1,
						pageSize: 100,
						current: 1,
						showSizeChanger: true,
						pageSizeOptions: ['5', '10', '20', '50', '100'],
						showTotal: (total) =>
							`${this.$lang.GetLangByKey('Total')} ${total} ${this.$lang.GetLangByKey('Rows')}`,
						onShowSizeChange: (current, pageSize) => this.onSizeChange(current, pageSize),
						onChange: (page, pageSize) => this.onPageChange(page, pageSize),
						total: 0, //总条数
					},
				},
			};
		},
		watch: {},
		computed: {},
		methods: {
			onSizeChange(page, size) {
				this.datatable.pagination.current = page;
				this.datatable.pagination.pageNo = page;
				this.datatable.pagination.pageSize = size;
				//this.getOrderList();
			},
			onPageChange(page, size) {
				this.datatable.pagination.current = page;
				this.datatable.pagination.pageNo = page;
				this.datatable.pagination.pageSize = size || this.datatable.pagination.pageSize;
				this.getOrderList();
			},
			async getOrderList() {
				let param = this.searchModel;
				var res = await userApi.GetAcceptTagAnchorList(param);
				if (res.ret_code == 200) {
					this.datatable.dataSource = res.ret_obj;
				}
			},
		},
		created() {},
		async mounted() {
			this.getOrderList();
		},
	};
</script>

<style lang="scss" scoped>
	.contentWarp {
		width: 100%;
		height: 100%;
		background-color: white;

		:deep(.ant-input) {
			min-width: 150px;
			min-height: 32px;
			border-radius: 6px;
		}

		.ant-input-group.ant-input-group-compact
			> .ant-select:last-child
			> :deep(.ant-select-selector) {
			min-width: 150px;
			border-radius: 6px;
			min-height: 32px;
		}

		.ant-input-group.ant-input-group-compact > * {
			border-radius: 6px;
		}

		.content_header {
			padding: 2%;
			display: flex;

			.header {
				.header_item {
					width: 10px;
					height: 72px;
					background: linear-gradient(180deg, #ffbcb0 0%, #ff8778 100%);
					border-radius: 4px;
					display: inline-block;
				}

				.header_item_1 {
					width: 130px;
					height: 50px;
					font-size: 36px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #0086f5;
					line-height: 50px;
					padding-left: 1rem;
				}

				.header_item_2 {
					width: 174px;
					height: 33px;
					font-size: 24px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #0086f5;
					line-height: 33px;
					padding-left: 1rem;
					white-space: nowrap;
					/* overflow: hidden; */
					text-overflow: ellipsis;
				}
			}
		}

		.content_body {
			::v-deep {
				.ant-table-cell {
					border-bottom: 1px solid rgba(0, 134, 245, 0.34);
					text-align: center;
					font-size: 14px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #0086f5;
				}

				.ant-table-wrapper {
					clear: both;
					max-width: 100%;
					padding: 0px 2% 0px 2%;
				}
			}
		}
	}
</style>
